// ==============================
// 目次自動生成
// ==============================

// -------------------------------------
// itemprop名の定義
// -------------------------------------
const articleBodyItemProp = "articleBody";
const tableOfContentsItemProp = "tableOfContents";

// -------------------------------------
// 記事本文（articleBody）の要素を取得
// -------------------------------------
const getArticleBody = () => {
  return document.querySelector(`[itemprop="${articleBodyItemProp}"]`);
};

// -------------------------------------
// 記事本文中の見出しを取得（目次内のh2,h3は除外）
// -------------------------------------
const getHeadings = () => {
  const articleBody = getArticleBody();
  if (!articleBody) return [];
  const all = articleBody.querySelectorAll("h2, h3");
  return Array.from(all).filter(
    (h) => !h.closest(`[itemprop="${tableOfContentsItemProp}"]`)
  );
};

// -------------------------------------
// 既に目次が存在するか確認
// -------------------------------------
const existsTableOfContents = () => {
  return !!document.querySelector(`[itemprop="${tableOfContentsItemProp}"]`);
};

// -------------------------------------
// 見出しテキストをスラッグ化（ID用）＋一意化
// -------------------------------------
const toSlug = (text) => {
  const t = (text || "").trim();
  const base = t
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w\-ぁ-んァ-ン一-龥ー]/g, "");
  return base || "section";
};

// -------------------------------------
// 見出しにIDを付与（重複を避ける）
// -------------------------------------
const addIdToHeading = () => {
  const headings = getHeadings();
  if (!headings.length) return;

  const used = new Set();
  headings.forEach((h) => {
    const base = toSlug(h.textContent);
    let candidate = base;
    let n = 2;
    while (used.has(candidate) || document.getElementById(candidate)) {
      candidate = `${base}-${n++}`;
    }
    used.add(candidate);
    h.id = candidate;
  });
};

// -------------------------------------
// アンカーリンク生成（クリック時にスクロール補正）
// -------------------------------------
const generateAnchor = (id, text) => {
  const anchor = document.createElement("a");
  anchor.style.display = "block";
  anchor.style.width = "100%";
  anchor.style.padding = 0;
  anchor.style.margin = 0;
  anchor.style.lineHeight = "21px";
  anchor.style.fontSize = "14px";
  anchor.style.color = "#333";
  anchor.appendChild(document.createTextNode(text));
  anchor.setAttribute("href", `#${id}`);

  // スクロール位置補正：PC120px、スマホ100px
  anchor.addEventListener("click", (e) => {
    e.preventDefault();
    const target = document.getElementById(id);
    if (!target) return;

    const isMobile = window.innerWidth <= 749;
    const offset = isMobile ? 100 : 120;
    const top =
      target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top,
      behavior: "smooth",
    });
  });

  return anchor;
};

// -------------------------------------
// リストアイテムを生成
// -------------------------------------
const generateListItem = (id, text, isNest = false) => {
  const li = document.createElement("li");
  li.style.padding = "8px 0";
  li.style.margin = 0;
  li.style.listStyleType = "none";
  if (isNest) li.style.paddingLeft = "24px";
  li.appendChild(generateAnchor(id, text));
  return li;
};

// -------------------------------------
// ulリスト全体を生成
// -------------------------------------
const generateList = (headings) => {
  if (!headings || !headings.length) return null;
  const ul = document.createElement("ul");
  ul.style.padding = 0;
  ul.style.margin = "16px 0 0";
  ul.style.listStyle = "none";
  headings.forEach((h) => {
    ul.appendChild(
      generateListItem(h.id, h.textContent.trim(), h.tagName === "H3")
    );
  });
  return ul;
};

// -------------------------------------
// 「目次」タイトル生成
// -------------------------------------
const generateTitle = () => {
  const title = document.createElement("div");
  title.style.fontSize = "20px";
  title.style.fontWeight = "700";
  title.style.margin = 0;
  title.style.color = "#333";
  title.style.lineHeight = 1.5;
  title.style.letterSpacing = "0.04em";
  title.appendChild(document.createTextNode("目次"));
  return title;
};

// -------------------------------------
// 目次ブロック全体を生成
// -------------------------------------
const generateTableOfContents = (headings) => {
  if (!headings || !headings.length) return null;

  const toc = document.createElement("nav");
  toc.setAttribute("itemprop", tableOfContentsItemProp);
  toc.style.padding = "36px";
  toc.style.margin = "36px 0";
  toc.style.backgroundColor = "#f7f7f7";
  toc.appendChild(generateTitle());
  const list = generateList(headings);
  if (list) toc.appendChild(list);
  return toc;
};

// -------------------------------------
// 目次を記事内の最初の見出し前に挿入
// -------------------------------------
const addTableOfContents = () => {
  const articleBody = getArticleBody();
  if (!articleBody || existsTableOfContents()) return;

  const headings = getHeadings();
  if (!headings.length) return;

  const toc = generateTableOfContents(headings);
  if (!toc) return;

  articleBody.insertBefore(toc, headings[0]);
};

// -------------------------------------
// 実行順：ID付与 → 目次生成
// -------------------------------------
addIdToHeading();
addTableOfContents();
